"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { DataSetModel } from "@/models/dataset.model";
export let ShopFormNewshopModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.is_auto_cookie_sync = false;
    this.lock_account = false;
    this.ui_language = "";
    this.ui_languages = new DataSetModel();
  }
};
ShopFormNewshopModel.model = "ebusiness.shop.form.newshop.options";
ShopFormNewshopModel = __decorateClass([
  Annotation.ModelMeta
], ShopFormNewshopModel);
export let UiLanguageModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.abbreviation = "";
    this.name = "";
  }
};
UiLanguageModel.model = "ui.language";
UiLanguageModel = __decorateClass([
  Annotation.ModelMeta
], UiLanguageModel);
